import { render, staticRenderFns } from "./app-send-email.vue?vue&type=template&id=e21b4bd4&"
import script from "./app-send-email.vue?vue&type=script&lang=js&"
export * from "./app-send-email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports